import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { Card, Form, Row, Col } from 'react-bootstrap';
import { Button, ButtonGroup } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import HeaderQuoteAi from './headerQuoteAi';
import SidebarQuoteAi from '../quote/sidebarQuoteAi';
import RightHeaderPage from './rightHeader';

const ContactInformationPage = () => {
  const navigate = useNavigate();
  const [isMapVisible, setIsMapVisible] = useState(false);
  const handleShowMap = () => {
    // Logic to show map (this could be opening a modal, for example)
    setIsMapVisible(true);
    alert('Map opened!'); // For simplicity, just alerting here
  };

  return (
    <>
      <div id="quoteAi">
        <HeaderQuoteAi />
        <div className="QuoteDashboard">
          <div className="main">
            <div className="pageformBloack">
              <div className=" container-fluid">
                <div className="row">
                  <div className="col-12 col-md-12 col-lg-2">
                    <div className="sidebar-visible">
                      <SidebarQuoteAi />
                    </div>
                  </div>
                  <div className="col-12 col-md-12 col-lg-8 gx-2 main-quotescroll">
                    <div className="whiteBoxCont ">
                      <div className="quote_buttongroup">
                        <div className="form_action_buttons mb-2">
                          <ButtonGroup>
                            <Button
                              variant="outline-back"
                              className="button-gap"
                              onClick={() => navigate('/quoteAI/InsuredInformationPage')}
                            >
                              Back
                            </Button>
                            <Button
                              variant="outline-next"
                              className="button-gap"
                              onClick={() => navigate('/quoteAI/PolicyTermPage')}
                            >
                              Next
                            </Button>
                          </ButtonGroup>
                          <ButtonGroup>
                            <Button variant="outline-cancel" className="button-gap">
                              Cancel
                            </Button>
                            <Button variant="primary-save" className="button-gap">
                              Save
                            </Button>
                          </ButtonGroup>
                        </div>
                      </div>
                      <div className="scrollable-content">
                        <div className="formcard-container mrgTop">
                          {/* Insured Information Section */}
                          <Card className="mb-4 formpage-card">
                            <Card.Header className="formpage-card-header">
                              Contact Information
                            </Card.Header>
                            <Card.Body>
                              <Row>
                                {/* Full Name */}
                                <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>First Name</Form.Label>
                                    <Form.Control type="text" placeholder="Enter First Name" />
                                  </Form.Group>
                                </Col>

                                {/* Middle Name */}
                                <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>Middle Name / Initial</Form.Label>
                                    <Form.Control type="text" placeholder="Enter Middle Name" />
                                  </Form.Group>
                                </Col>

                                {/* Last Name */}
                                <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>Last Name</Form.Label>
                                    <Form.Control type="text" placeholder="Enter Last Name" />
                                  </Form.Group>
                                </Col>

                                {/* Email Address */}
                                <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>Email Address</Form.Label>
                                    <Form.Control type="email" placeholder="Enter your email" />
                                  </Form.Group>
                                </Col>

                                {/* Office Number */}
                                <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>Office Number</Form.Label>
                                    <Form.Control type="tel" placeholder="Enter office number" />
                                  </Form.Group>
                                </Col>

                                {/* Mobile Number */}
                                <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>Mobile Number</Form.Label>
                                    <Form.Control type="tel" placeholder="Enter mobile number" />
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Card.Body>
                          </Card>

                          {/* Address Section */}
                          <Card className="formpage-card">
                            <Card.Header className="formpage-card-header">
                              Primary Address
                            </Card.Header>
                            <Card.Body>
                              <Row>
                                {/* Zip */}
                                <Col xs={12} sm={6} md={3} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>Zip</Form.Label>
                                    <Form.Control type="text" placeholder="Enter zip code" />
                                  </Form.Group>
                                </Col>

                                {/* State */}
                                <Col xs={12} sm={6} md={3} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>State</Form.Label>
                                    <Form.Control type="text" placeholder="Enter state" />
                                  </Form.Group>
                                </Col>

                                {/* Country */}
                                <Col xs={12} sm={6} md={3} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>Country</Form.Label>
                                    <Form.Control type="text" placeholder="Enter country" />
                                  </Form.Group>
                                </Col>

                                {/* City */}
                                <Col xs={12} sm={6} md={3} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>City</Form.Label>
                                    <Form.Control type="text" placeholder="Enter city" />
                                  </Form.Group>
                                </Col>

                                {/* Street Address */}
                                <Col xs={12} sm={6} md={12} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>Street Address</Form.Label>

                                    {/* Street Address Line 1 */}
                                    <Form.Control
                                      as="textarea"
                                      placeholder="Enter street address"
                                      className="mb-3" // Adds space between fields
                                    />

                                    {/* Street Address Line 2 */}
                                    <Form.Control
                                      as="textarea"
                                      placeholder="Enter street address (optional)"
                                      className="mb-3" // Adds space between fields
                                    />
                                  </Form.Group>
                                </Col>

                                <Col xs={12} sm={6} md={6} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    {/* Align Checkbox, Label, and Button in a row */}
                                    <div className="d-flex align-items-center gap-3">
                                      {/* Checkbox First */}
                                      <Form.Check
                                        type="checkbox"
                                        id="primary-location-checkbox"
                                        className="mr-2"
                                      />

                                      {/* Label After the Checkbox */}
                                      <Form.Label className="mb-0">Primary Location</Form.Label>

                                      {/* Show in Map Button */}
                                      <div className="quote_buttongroup">
                                        <Button
                                          type="button"
                                          variant="primary-save"
                                          className="button-gap"
                                          onClick={handleShowMap}
                                        >
                                          {/* Map SVG Icon */}
                                          <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            className="me-2"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M8 0C5.23858 0 3 2.23858 3 5C3 7.76142 8 15 8 15C8 15 13 7.76142 13 5C13 2.23858 10.7614 0 8 0ZM8 7C6.34315 7 5 5.65685 5 5C5 4.34315 6.34315 3 8 3C9.65685 3 11 4.34315 11 5C11 5.65685 9.65685 7 8 7Z"
                                              fill="#FFFFFF"
                                            />
                                          </svg>
                                          Show in Map
                                        </Button>
                                      </div>
                                    </div>

                                    {/* Conditionally render the map (for demonstration purposes) */}
                                    {isMapVisible && (
                                      <div className="mt-3">
                                        <p>Map is now visible!</p>
                                      </div>
                                    )}
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Card.Body>
                          </Card>
                          {/* Mailing Address Section */}
                          <Card className="formpage-card">
                            <Card.Header className="formpage-card-header">
                              Mailing Address
                            </Card.Header>
                            <Card.Body>
                              <Row>
                                {/* Zip */}
                                <Col xs={12} sm={6} md={3} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>Zip</Form.Label>
                                    <Form.Control type="text" placeholder="Enter zip code" />
                                  </Form.Group>
                                </Col>

                                {/* State */}
                                <Col xs={12} sm={6} md={3} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>State</Form.Label>
                                    <Form.Control type="text" placeholder="Enter state" />
                                  </Form.Group>
                                </Col>

                                {/* Country */}
                                <Col xs={12} sm={6} md={3} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>
                                      County{' '}
                                      <i
                                        className="info-icon"
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content="County"
                                      >
                                        <svg
                                          width="16"
                                          height="16"
                                          viewBox="0 0 13 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                            fill="none"
                                            stroke="#76D1B9"
                                          />
                                        </svg>
                                      </i>
                                      <ReactTooltip
                                        id="my-tooltip"
                                        style={{ backgroundColor: '#2563eb' }}
                                      ></ReactTooltip>
                                    </Form.Label>
                                    <Form.Control type="text" placeholder="Enter county" />
                                  </Form.Group>
                                </Col>

                                {/* City */}
                                <Col xs={12} sm={6} md={3} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>
                                      City
                                      <i
                                        className="info-icon"
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content="City"
                                      >
                                        <svg
                                          width="16"
                                          height="16"
                                          viewBox="0 0 13 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                            fill="none"
                                            stroke="#76D1B9"
                                          />
                                        </svg>
                                      </i>
                                      <ReactTooltip
                                        id="my-tooltip"
                                        style={{ backgroundColor: '#2563eb' }}
                                      ></ReactTooltip>
                                    </Form.Label>
                                    <Form.Control type="text" placeholder="Enter city" />
                                  </Form.Group>
                                </Col>

                                {/* Street Address */}
                                <Col xs={12} sm={6} md={12} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>
                                      Street Address
                                      <i
                                        className="info-icon"
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content="Address"
                                      >
                                        <svg
                                          width="16"
                                          height="16"
                                          viewBox="0 0 13 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                            fill="none"
                                            stroke="#76D1B9"
                                          />
                                        </svg>
                                      </i>
                                      <ReactTooltip
                                        id="my-tooltip"
                                        style={{ backgroundColor: '#2563eb' }}
                                      ></ReactTooltip>
                                    </Form.Label>

                                    {/* Street Address Line 1 */}
                                    <Form.Control
                                      as="textarea"
                                      placeholder="Enter street address"
                                      className="mb-3" // Adds space between fields
                                    />

                                    {/* Street Address Line 2 */}
                                    <Form.Control
                                      as="textarea"
                                      placeholder="Enter street address (optional)"
                                      className="mb-3" // Adds space between fields
                                    />
                                  </Form.Group>
                                </Col>

                                <Col xs={12} sm={6} md={12} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    {/* Align Checkbox, Label, and Button in a row */}
                                    <div className="d-flex align-items-center gap-3">
                                      {/* Checkbox First */}
                                      <Form.Check
                                        type="checkbox"
                                        id="primary-location-checkbox"
                                        className="mr-2"
                                      />

                                      {/* Label After the Checkbox */}
                                      <Form.Label className="mb-0">Primary Location</Form.Label>

                                      {/* Show in Map Button */}
                                      <div className="quote_buttongroup">
                                        <Button
                                          type="button"
                                          variant="primary-save"
                                          className="button-gap"
                                          onClick={handleShowMap}
                                        >
                                          {/* Map SVG Icon */}
                                          <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            className="me-2"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M8 0C5.23858 0 3 2.23858 3 5C3 7.76142 8 15 8 15C8 15 13 7.76142 13 5C13 2.23858 10.7614 0 8 0ZM8 7C6.34315 7 5 5.65685 5 5C5 4.34315 6.34315 3 8 3C9.65685 3 11 4.34315 11 5C11 5.65685 9.65685 7 8 7Z"
                                              fill="#FFFFFF"
                                            />
                                          </svg>
                                          Show in Map
                                        </Button>
                                      </div>
                                    </div>

                                    {/* Conditionally render the map (for demonstration purposes) */}
                                    {isMapVisible && (
                                      <div className="mt-3">
                                        <p>Map is now visible!</p>
                                      </div>
                                    )}
                                  </Form.Group>
                                </Col>

                                {/* Latitude */}
                                <Col xs={12} sm={6} md={6} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>Latitude</Form.Label>
                                    <Form.Control type="text" placeholder="Enter latitude" />
                                  </Form.Group>
                                </Col>

                                {/* Longitude */}
                                <Col xs={12} sm={6} md={6} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>Longitude</Form.Label>
                                    <Form.Control type="text" placeholder="Enter longitude" />
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Card.Body>
                          </Card>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-12 col-lg-2">
                    <div className="sticky-right-top">
                      <RightHeaderPage />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ContactInformationPage;
